import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IJSONProvider} from "data/providers/json/json.provider";
import {ConferenceType} from "data/enums";

export interface IConference {
	id: number;
	abbreviation: string;
	name: string;
}

export interface IConferencesStore {
	get conferences(): IConference[];
	get afcConferenceId(): number;
	get nfcConferenceId(): number;

	fetchConferences(): Promise<void>;
	getConferenceIdByType(type: ConferenceType): number;
}

@injectable()
export class ConferencesStore implements IConferencesStore {
	@observable private _list: IConference[] = [];

	get conferences() {
		return this._list;
	}

	get afcConferenceId() {
		const afc = this._list.find((el) => el.abbreviation.toLowerCase() === ConferenceType.AFC);

		return afc?.id ?? 0;
	}

	get nfcConferenceId() {
		const nfc = this._list.find((el) => el.abbreviation.toLowerCase() === ConferenceType.NFC);

		return nfc?.id ?? 0;
	}

	constructor(@inject(Bindings.JSONProvider) private _jSONProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	@action
	async fetchConferences() {
		const {data} = await this._jSONProvider.conferences();

		runInAction(() => {
			this._list = data.items;
		});
	}

	getConferenceIdByType(type: ConferenceType) {
		return this._list.find((el) => el.abbreviation.toLowerCase() === type)?.id ?? 0;
	}
}
